import { createClientCityRangeRequest } from "../../data/clientCityRangeApi";
import { validateClientCityRangePayload } from "../validator/validateClientCityRangePayload";

export async function createClientCityRangeUseCase(payload) {
  const error = validateClientCityRangePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createClientCityRangeRequest(payload);
}
